const SKIP_LABELS = {
  registration_not_verified: "tournament registration not verified yet (verify registration first)",
  not_found: "not linked to a tournament registration payment",
  invalid_payment: "invalid payment id",
  invalid_flag: "invalid verification flag",
  unknown: "other",
};

/**
 * Human-readable suffix for accountant tournament payment bulk verify responses.
 * @param {Record<string, number>|undefined} skipReasons
 */
export function formatTournamentBulkPaymentSkipSuffix(skipReasons) {
  if (!skipReasons || typeof skipReasons !== "object") return "";
  const parts = Object.entries(skipReasons)
    .filter(([, n]) => Number(n) > 0)
    .map(([code, n]) => `${n} ${SKIP_LABELS[code] || String(code).replace(/_/g, " ")}`);
  if (!parts.length) return "";
  return ` Skipped because: ${parts.join("; ")}.`;
}
